import { createUseStyles } from 'react-jss'

export default createUseStyles({
  button: {
    margin: '0 auto',
    width: '80%'
  },
  iconContainer: {
    display: 'flex',
    justifyContent: 'center'
  },
  icon: {
    '& path': {
      stroke: 'url(#error)'
    }
  },
  modalTextContainer: {
    alignItems: 'center',
    display: 'flex',
    flexDirection: 'column',
    margin: '30px 0',
    padding: '10px 20px',
    textAlign: 'center'
  },
  bodyContainer: {
    display: 'flex'
  }
})
